























import { Component, Mixins, Model, Prop, Emit } from "vue-property-decorator";
import { DocumentSummary } from "../../../domain/document";
import DocumentSelectorListStyle from "./DocumentSelectorListStyle.vue";
import DocumentSelectorCardStyle from "./DocumentSelectorCardStyle.vue";
import DocumentSelectorMixin from "./mixins/DocumentSelectorMixin.vue";
import TabSelector from "../../system/selectors/TabSelector.vue";
import { ISortParameter } from "../../system";

@Component({
  components: {
    DocumentSelectorListStyle,
    DocumentSelectorCardStyle,
    TabSelector,
  },
})
export default class DocumentSelector extends Mixins() {
  static readonly Tabs: {[key: string]: { name: string, component: string }} = {
    list: {
      name: "リスト",
      component: "DocumentSelectorListStyle",
    },
    card: {
      name: "カード",
      component: "DocumentSelectorCardStyle",
    },
  };
  static readonly defaultSelectorTab: { name: string, component: string } = DocumentSelector.Tabs.card;

  @Model("input")
  value: DocumentSummary;

  @Prop()
  documents: DocumentSummary[];

  @Prop()
  sortParameter: ISortParameter;

  @Prop()
  shouldShowPatientColumns: boolean;

  @Emit()
  input(value: DocumentSummary): void {}

  @Emit()
  onCurrentTabComponentUpdated(isList: boolean): void {}

  @Emit("sortChange")
  onSortChanged(): void {}

  @Emit("documentDoubleClick")
  onRowDoubleClicked(): void {}

  $refs!: {
    component: DocumentSelectorMixin;
  };

  data(): any {
    return {
      visibleSelectorTabs: [
        DocumentSelector.Tabs.list,
        DocumentSelector.Tabs.card,
      ],
      selectedSelectorTab: DocumentSelector.defaultSelectorTab,
    };
  }
  visibleSelectorTabs: { name: string, component: string }[];
  selectedSelectorTab: { name: string, component: string };

  mounted() {
    this.selectedSelectorTab = this.defaultSelectorTab;
  }

  resetInfiniteLoading(): void {
    (this.$refs.component as DocumentSelectorMixin).resetInfiniteLoading();
  }

  get defaultSelectorTab(): { name: string, component: string } {
    const key = this.$configuration.behavior.document.list.selector.defaultSelectedTab;
    return DocumentSelector.Tabs[key]
      ? DocumentSelector.Tabs[key]
      : DocumentSelector.defaultSelectorTab;
  }

  get currentTabComponent(): string {
    this.input(null); // タブを切り替えた際、一旦クリアするために通知する
    this.onCurrentTabComponentUpdated(this.selectedSelectorTab === DocumentSelector.Tabs.list);
    return this.selectedSelectorTab.component;
  }

  get source(): DocumentSummary {
    return this.value;
  }

  set source(value: DocumentSummary) {
    this.input(value);
  }

  clearSort(): void {
    this.$refs.component.clearSort();
  }
}
